import { Button, Stack } from "~/common/mui";
import { StepHeader } from "./StepHeader";
import { redirectToUrl } from "~/utils/url/urlUtils";
import { HOMEPAGE } from "~/utils/url/staticUrls";
import { useTranslation } from "react-i18next";
import { useFormContext } from "react-hook-form";
import type { OnboardingFormValues } from "./useOnboardingForm";

export const OnboardingCompleted = () => {
  const { t } = useTranslation();
  const { watch } = useFormContext<OnboardingFormValues>();

  const firstName = watch("firstName");
  return (
    <Stack gap={4} alignItems={"center"}>
      <Stack gap={2}>
        <StepHeader
          title={t("onboarding.overlay.completed.title", {
            name: firstName,
          })}
          subtitle={t("onboarding.overlay.completed.subtitle")}
        />
      </Stack>
      <Button
        onClick={() => {
          redirectToUrl(HOMEPAGE);
        }}
      >
        {t("onboarding.overlay.completed.startBrowsing")}
      </Button>
    </Stack>
  );
};
